<mat-form-field2
  class="mat-block"
  [tooltip]="showBookingTooltip && selectedBooking ? bookingTooltipTpl : tooltipText"
  [tooltipAppendToBody]="true"
>
  <app-select
    [bindValue]="bindValue"
    bindLabel="guestNameView"
    [multiple]="false"
    [items]="inquiries$ | async"
    [compareWith]="compareWith"
    [searchable]="true"
    (searchChange)="onSearch($event)"
    [formControl]="ctrl"
    [placeholder]="placeholder"
    (selectedChange)="onSelect($event)"
    [required]="required"
    [disabled]="ctrl.disabled"
    [showBlankItem]="showBlankItem"
    [itemHeight]="55"
  >
    <ng-template selectLabel let-items="items">
      <ng-container *ngFor="let item of items">
        <b>{{ item?.guestNameView || '[Unknown]' }}</b> at {{ item?.rentalId | rentalName | async }}
      </ng-container>
    </ng-template>
    <ng-template selectItem let-item="item">
      <ng-template [ngTemplateOutlet]="bookingTpl" [ngTemplateOutletContext]="{ item: item }"></ng-template>
    </ng-template>
  </app-select>
  <a
    matSuffix
    *ngIf="refreshable && !ctrl.disabled"
    (click)="onRefresh()"
    i18n-matTooltip
    matTooltip="Refresh"
    matTooltipPosition="above"
    ><i class="far fa-sync"></i
  ></a>
  <mat-error *ngIf="ctrl?.touched && ctrl?.hasError('required')" i18n> Inquiry is required </mat-error>
</mat-form-field2>

<ng-template #bookingTooltipTpl let-item="item">
  <ng-template [ngTemplateOutlet]="bookingTpl" [ngTemplateOutletContext]="{ item: selectedBooking }"></ng-template>
</ng-template>

<ng-template #bookingTpl let-item="item">
  <div *ngIf="item" style="line-height: 1.1" class="py-1">
    <div class="text-truncate">
      <b>{{ item.guestNameView || '[Unknown]' }}</b> at
      <app-rental-name [rentalId]="item.rentalId" class="d-inline-flex"></app-rental-name>
    </div>
    <small class="text-muted">
      <ng-container i18n>starting </ng-container>{{ item.guestArrive | epoch : 'date'
      }}<ng-container i18n></ng-container> ending {{ item.guestDepart | epoch : 'date' }}
    </small>
  </div>
</ng-template>
